import { AppSettingService } from 'src/app/services/app-setting.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  title = "ManagePractice"
  constructor(private appSettingService: AppSettingService) { }
  isIndividualProvider: any = false;
  ngOnInit(): void {
    this.isIndividualProvider = this.appSettingService.loggedInUser.IsIndividual
  }

}
